module.exports = {
    general_error: "Neočakávaná chyba",
    hierarchy_duplicites: "Objekt už existuje",
    api_communication_error: "Chyba v komunikácii so serverom",
    data_not_found: "Nenašli sa žiadne uložené údaje",
    appliances_imprints_not_found: "Neexistujú žiadne odtlačky spotrebičov",
    success_removed_imprint: "Otlačok spotrebiča bol úspešne odstránený",
    success_removed_all_imprints: "Všetky spotrebiče boli úspešne odstránené",
    energy_not_found_for_selected_time: "Nenašla sa uložená energia pre zvolené obdobie",
    password_successfully_changed: "Heslo bolo úspešne zmenené",
    passwords_equal: "Heslá musia byť rozdielne",
    any_assigned_devices: "Niesu priradené zariadenia",
    object_not_empty: "Objekt nieje prázdny",
    appliance_imprint_save_success: "Odtlačok spotrebiča úspešne uložený",
    error: "Vyskytla sa chyba",
    success_removed_device: "Zariadenie úspešne zmazané",
    success: "Úspech",
    success_removed_appliance: "Spotrebič bol úspešne odstránený",
    many_edges: "Boli detekované viac ako 2 hrany",
    small_edges: "Boli detekované menej ako 2 hrany",
    any_edge: "Nebola detekovaná žiadna hrana",
    duplicate_appliance: "Spotrebič s rovnakým menom už existuje",
    delete_energy_succes: "Energia bola úspešne zmazaná",
    device_not_responding_or_offline: "Zariadenie neodpovedá alebo je nedostupné",
    lora_settings_successfully_set: "LoRa nastavenia boli úspešne nakonfigurované",
    success_removed_test_case: "Testovací prípad úspešne zmazaný",
    success_removed_test_profile: "Testovací profil úspešne zmazaný",
    login_credentials_incorrect: "Nesprávne prihlasovacie údaje",
    if_want_testing_go_to_section_tesing: "Pre toto zariadenie nie je uložený žiaden výsledok testovania, ak chcete zariadenie testovať, prejdite do sekcie Testovanie",
    before_start_testing: "Pred začatím testovacieho procesu pripojte testovacie zariadenie ku generátoru",
    before_start_another_testing: "Pred začatím ďalšieho testovacieho procesu pripojte testovacie zariadenie ku generátoru",
    copy_token_to_clipboard: "Kopírovať token",
    token_copied: "Token bol skopírovaný",
    no_tokens_available: "Nie sú dostupné žiadne tokeny",
    settings_successfully_saved: "Nastavenia boli úspešne uložené",
    choose_disconnector_menu: "Vyber disconnector alebo skupinu v menu",
    current_firmware_version: "Súčasná verzia softvéru",
    available_firmware_version: "Dostupný nový softvér verzie",
    starting_upgrade: "Spúšta sa aktualizácia...",
    upgrading: "Aktualizácia...",
    rebooting: "Reštart zariadenia...",
    upgrade_failed: "Upgrade failed",
    upgrade_timeout: "Vypršal čas pre aktualizáciu. ZARIADENIE NIE JE STABILNÉ",
    upgrade_not_available: "Aktualizácia softvéru nie je k dispozícii pre toto zariadenie",
    select_image_and_upload_map: "Vyber obrázok a nahraj mapu",
    file_format_not_supported: "Nepodporovaný formát súboru",
    file_too_large: "Súbor je príliš veľký, maximálna povolená veľkosť je 1 MB",
    image_file_upload_failed: "Nahranie obrázkového súboru zlyhalo",
    loading_image_failed: "Načítanie obrázka zlyhalo",
    please_wait: "Prosím čakajte...",
    success_saved_control_map: "Ovládacia mapa bola úspešne uložená",
    device_status_change: "Zariadenie je",
    turn_on_relay: "Zapnuté",
    turn_off_relay: "Vypnuté",
    notify_anomaly_S_T: "Anomália doby trvania medzi zapnutím a vypnutím spotrebiča",
    notify_anomaly_S_D: "Anomália trvania chodu",
    notify_anomaly_L_D: "Anomália na dennej úrovni",
    notify_anomaly_L_W: "Anomália na týždennej úrovni",
    notify_anomaly_L_M: "Anomália na mesačnej úrovni",
    notify_anomaly_L_Y: "Anomália na ročnej úrovni",
    oauth_cookies_disabled: "V súčasnom prostredí nie sú povolené cookies. Preto prihlasovací formulár Google nebude povolený",
    ws_online: "Ste znova online",
    ws_offline: "Momentálne ste offline"
  }